import { render, staticRenderFns } from "./thirdparties-page.vue?vue&type=template&id=103d6324&"
import script from "./thirdparties-page.vue?vue&type=script&lang=js&"
export * from "./thirdparties-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports